import React from 'react';
import { PortalStatCard } from '../PortalPageShell';

export default function AttendanceMonthSummary({ summary }) {
  if (!summary) return null;

  const pct = summary.attendance_percentage ?? summary.percentage ?? 0;

  return (
    <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
      <PortalStatCard label="Working days" value={summary.working_days ?? 0} />
      <PortalStatCard label="Present" value={summary.present_days ?? summary.present ?? 0} />
      <PortalStatCard label="Absent" value={summary.absent_days ?? summary.absent ?? 0} />
      <PortalStatCard label="Leave" value={summary.leave_days ?? 0} />
      <PortalStatCard label="Attendance %" value={`${pct}%`} />
    </div>
  );
}
